<div class="ant-pro-footer-bar" [ngClass]="{'default-theme':!(isNightTheme$|async),
'night-theme':(isNightTheme$|async)}">
  <div style="flex: 1 1 0">
    <ng-container *ngTemplateOutlet="leftTpl||defaultTpl"></ng-container>
  </div>

  <ng-content></ng-content>
</div>
<ng-template #defaultTpl>
</ng-template>
